import axios from 'axios';
import apiService from '../apiService';

export default async function updatePhotoAttributeValue(
  guestId = '',
  attributeId = '',
  value = '',
) {
  try {
    let _request = {
      url: `${apiService.getUrl().faceRecognition}faceDetection/updatePhotoAttributeValue`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        guestId: guestId,
        attributeId: attributeId,
        value: value,
      }
    }
    const _ret = await axios(_request);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;
  } catch (error) {
    console.log('Error updatePhotoAttributeValue', error);
    throw error;
  }
}
